import { CallReason } from "@closerplatform/closer-sdk";
import { MINUTE_MILLIS } from "@fidget/common/utils/timeUtils";
import { Instance, types } from "mobx-state-tree";
import { intl } from "@fidget/common/i18n/TypedIntl";
import { CallEndedPayload } from "@fidget/common/models/chat/chatItems";
import { MessageTag } from "@fidget/common/models/messageTag";
import { ChatItemType } from "../ChatItemType";
import { BaseChatItem } from "./BaseChatItem";

export const CTAEventChatItem = types
  .compose(
    "CTAEventChatItem",
    BaseChatItem,
    types.model({
      type: types.literal(ChatItemType.CTAEvent),
      subtype: types.enumeration<MessageTag>("CallEventSubtype", Object.values(MessageTag)),
      eventData: types.frozen<CallEndedPayload>(),
      /** fallback message */
      message: types.maybe(types.string)
    })
  )
  .views((self) => ({
    get text() {
      if (self.subtype === MessageTag.CALL_ENDED) {
        const event = self.eventData as CallEndedPayload;
        const durationInMinutes = event.duration && Math.ceil(event.duration / MINUTE_MILLIS);
        switch (event.reason) {
          case CallReason.TimeLimitExceeded:
            return intl.formatMessage("conversation.event.callTimeLimitExceeded");
          default:
            return durationInMinutes
              ? intl.formatMessage("conversation.event.callEnded", { durationInMinutes })
              : intl.formatMessage("conversation.event.callCancelled");
        }
      } else if (self.subtype === MessageTag.CALL_UNSUCCESSFUL) {
        //
        return intl.formatMessage("conversation.event.callUnsuccessful.dashboard");
      }
      return self.message;
    }
  }));

export interface ICTAEventChatItem extends Instance<typeof CTAEventChatItem> {}
